module.exports = React.addons.CSSTransitionGroup;


//////////////////
// WEBPACK FOOTER
// external "React.addons.CSSTransitionGroup"
// module id = 856
// module chunks = 0